import { useTheme } from '@material-ui/core';
import { ColoredImageIcon } from '@room-match/shared-ui-components'; // Remove Styled Dialog
import AsyncMediaGallery from 'components/AsyncMediaGallery/AsyncMediaGallery';
import React, { Fragment, useCallback, useState } from 'react';
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog'; // Use talent app level folder styled dialog - Jerome
import { useMediaShareableProfileFormat } from 'shared/hooks/useMediaShareableProfileFormat';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import IMedia from 'shared/interfaces/IMedia';
import CommonHeader, { HeaderButton } from '../CommonHeader';
import { BorderedCont, Content, NoMediaCont } from '../Dashboard/Dashboard.style';
import RenderEditButton2 from '../Dashboard/RenderEditButton';
import ImageItem from '../Items/ImageItem';
import { ButtonCont, DeleteButton, DeleteCont, ModalButton, ModalCont } from '../Media.styles';
import useImagesHelper from '../useImagesHelper';
import { CustomTypography } from 'shared/elements/CustomTypography';
import CloseIcon from 'shared/components/Icon/CloseIcon';
import AddModal from 'pages/Profiles/EditProfile/Tabs/ImagesVideoAudio/Modals/AddModal';
import { FileType } from 'shared/enums/FileType';

interface Props {
  data: IMedia[];
  deleteMedia: (ids: string[], type?: FileType) => void;
  onClickEditImage: (images: IMedia[]) => void;
  onSelectAllImages: (images: IMedia[]) => void;
  onDropImages: (images: File[]) => void;
}
const Images: React.FC<Props> = ({ data: images, deleteMedia, onClickEditImage, onSelectAllImages, onDropImages }) => {
  const theme = useTheme();
  const { mappedData } = useMediaShareableProfileFormat(images);
  const { fetchingImageUrlToFile } = useImagesHelper();
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [show, setshow] = useState(false);
  const [all, setAll] = useState(false);
  const [selectedId, setselectedId] = useState<string[]>([]);
  const { width } = useWindowDimensions();
  const ICON_SIZE = width < 960 ? 30 : 40;
  const [addModal, setAddModal] = useState(false);
  const handleSelect = (media: IMedia) => {
    if (selectedId.indexOf(media.id) > -1) {
      setselectedId((ids) => ids.filter((id) => id !== media.id));
    } else {
      setselectedId((ids) => [...ids, media.id]);
    }
  };

  const handleDelete = () => {
    if (all) {
      const toDelete = images.map((i) => i.id);
      deleteMedia(toDelete, FileType.IMAGE);
    } else {
      deleteMedia(selectedId, FileType.IMAGE);
    }
    setshow(false);
    setselectedId([]);
  };

  const showWarning = (all: boolean) => {
    setAll(all);
    setshow(true);
  };

  const onEditAll = useCallback(() => {
    const filteredImages = images.filter((image) => selectedId.indexOf(image.id) !== -1);
    onSelectAllImages(filteredImages);
  }, [selectedId, images, onSelectAllImages]);

  const onClickSelect = useCallback(() => {
    if (selectedId.length === 0) {
      const ids = images.map((image) => image.id);
      setselectedId(ids);
    } else {
      setselectedId([]);
    }
  }, [selectedId, setselectedId, images]);

  const ContentAction = () => {
    return (
      <>
        {images.length !== 0 ? (
          <HeaderButton onClick={onClickSelect}>{selectedId.length === 0 ? 'SELECT ALL' : 'UNSELECT ALL'}</HeaderButton>
        ) : null}
        {selectedId.length !== 0 ? <HeaderButton onClick={() => onEditAll()}>EDIT SELECTED</HeaderButton> : null}
        <HeaderButton
          onClick={(e) => {
            e.stopPropagation();
            handleUpload();
          }}
        >
          {' '}
          UPLOAD
        </HeaderButton>
      </>
    );
  };

  const handleUpload = () => {
    setAddModal(true);
  };

  return (
    <BorderedCont>
      <CommonHeader
        icon={<ColoredImageIcon style={{ width: ICON_SIZE, height: ICON_SIZE, alignSelf: 'center' }} />}
        title="Images"
        subtitle={`${images.length} Total Files`}
        contentAction={<ContentAction />}
      />
      <DeleteCont>
        <p style={{ fontSize: width < 960 ? 15 : 18 }}>
          {selectedId.length ? `${selectedId.length} Media ` : 'No Media '}
          Selected
        </p>
        {selectedId.length ? (
          <>
            <DeleteButton style={{ marginLeft: width < 960 ? 'auto' : 20 }} onClick={() => showWarning(false)}>
              DELETE SELECTED
            </DeleteButton>
          </>
        ) : (
          ''
        )}
      </DeleteCont>
      <Content maxHeight={'none'}>
        {images?.length ? (
          images.map((m, key) => (
            <ImageItem
              key={m.attributes.modified_attachment_url}
              item={m}
              handleSelect={handleSelect}
              checked={selectedId.indexOf(m.id) > -1}
              onClick={() => {
                setImageIndex(key);
                setShowImageModal(true);
              }}
              renderElement={
                // This is from shared ui component (Project Level)
                // <RenderEditButton showLoader={fetchingImageUrlToFile} onClickEdit={() => onClickEditImage([m])} />

                // This is from local folder (Dashboard folder)
                <RenderEditButton2 showLoader={fetchingImageUrlToFile} onClickEdit={() => onClickEditImage([m])} />
              }
            />
          ))
        ) : (
          <NoMediaCont>
            <p style={{ marginTop: 50, fontSize: 16 }}>No Media Available</p>
          </NoMediaCont>
        )}
      </Content>
      <StyledDialog
        style={{ zIndex: 9999 }}
        open={addModal}
        onClose={() => setAddModal(false)}
        maxWidth="md"
        aria-labelledby="simple-dialog-title"
      >
        <AddModal
          close={() => setAddModal(false)}
          type="Images"
          openEditor={(file) => {
            onDropImages(file);
          }}
        />
      </StyledDialog>
      <StyledDialog
        style={{ zIndex: 9999 }}
        open={show}
        onClose={() => setshow(false)}
        maxWidth={false}
        aria-labelledby="simple-dialog-title"
      >
        <ModalCont>
          <CloseIcon
            style={{ width: 14, position: 'absolute', cursor: 'pointer', right: 15, top: 10 }}
            onClick={() => setshow(false)}
          />
          <CustomTypography fontSize={24}>
            Delete {all ? (images.length > 1 ? 'Images' : 'Image') : selectedId.length > 1 ? 'Images' : 'Image'}
          </CustomTypography>
          <CustomTypography fontSize={17}>
            Are you sure you want to delete {all ? images.length : selectedId.length}{' '}
            {all ? (images.length > 1 ? 'images' : 'image') : selectedId.length > 1 ? 'images' : 'image'}?
          </CustomTypography>
          <p style={{ marginTop: 33, textAlign: 'center', wordBreak: 'break-word', fontSize: 16 }}>
            <span style={{ color: '#ed3030' }}>
              {' '}
              This will remove{' '}
              {all
                ? images.length > 1
                  ? 'these images'
                  : 'this image'
                : selectedId.length > 1
                  ? 'these images'
                  : 'this image'}
            </span>{' '}
            from your media manager as well as any profile it is currently associated with, this cannot be undone.
          </p>
          <ButtonCont>
            <ModalButton style={{ backgroundColor: '#ed3030', color: '#fff' }} onClick={handleDelete}>
              Yes, delete {all ? (images.length > 1 ? 'images' : 'image') : selectedId.length > 1 ? 'images' : 'image'}
            </ModalButton>
            <ModalButton
              style={{ border: '1px solid #3e8bff', marginTop: 15, backgroundColor: 'transparent' }}
              onClick={() => setshow(false)}
            >
              Cancel
            </ModalButton>
          </ButtonCont>
        </ModalCont>
      </StyledDialog>
      {showImageModal ? (
        <AsyncMediaGallery
          data={mappedData || []}
          selectedIndex={imageIndex}
          type={'image'}
          openGallery={showImageModal}
          handleOpenGallery={() => setShowImageModal(false)}
          sharedTheme={theme.palette.type}
        />
      ) : (
        <Fragment />
      )}
    </BorderedCont>
  );
};

export default Images;
